import { useState } from "react";

import {
	Button,
	CardContent,
	CircularProgress,
	Grid,
	Paper,
	Typography,
} from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { DateTimePickerComponent } from "@/components/shared/date-time-picker-modal/date-time-picker.component";
import { ErrorModal } from "@/components/shared/modal/error-modal";
import { format } from "date-fns";
import { CheckmarkIcon, toast } from "react-hot-toast";
import { useTundishHMContext } from "../../context/TundishHeatMetricContext";
import { updateTundishHeatMetrics } from "../../repositories/TundishHMRepository";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiSelect-outlined.MuiSelect-outlined": {
				height: "70vh",
				minWidth: "200px",
				width: "80%",
				minHeight: "100%",
			},
		},
	}),
);

type Props = {
	isLoading: boolean;
	getTundishesFromAPI: Function;
};

export const TableTundish = ({ isLoading }: Props) => {
	const { state, actions } = useTundishHMContext();

	const [selected, setSelected] = useState<string[]>(["all"]);
	const [internalValue, setInternalValue] = useState<Date | null>(null);

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [localError, setLocalError] = useState<string | null>(null);

	const onLocalChange = (e: any) => {
		setSelected([...e.target.selectedOptions].map((o) => o.value));
	};

	const handleRecalculate = async () => {
		try {
			if (selected[0] === "all")
				await updateTundishHeatMetrics(
					selected[0],
					format(internalValue || new Date(), "yyyy-MM-dd HH:mm"),
				);
			else
				await updateTundishHeatMetrics(
					parseInt(selected[0]),
					format(internalValue || new Date(), "yyyy-MM-dd HH:mm"),
				);

			toast("Success!", {
				icon: <CheckmarkIcon />,
			});
		} catch (error) {
			setLocalError(error as string);
			setShowErrorModal(true);
		}
	};

	const tundishTitle = (rootNames: string[]) => {
		if (!rootNames[0]) return;
		if (rootNames[0] === "all") return "All";
		if (rootNames.length === 1) return "Tundish " + rootNames[0];
		else return "Tundish " + rootNames.join(", ");
	};

	return (
		<>
			{!isLoading ? (
				<>
					<Paper
						style={{
							width: "100%",
							padding: "20px",
							borderRadius: "0.75rem",
						}}
					>
						<Grid container>
							<Grid item xs={12}>
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<Typography
										variant="h5"
										style={{ paddingBottom: "20px", fontWeight: 600 }}
									>
										Tundish Heat Metrics
									</Typography>
								</div>
							</Grid>

							<Grid item md={3} xs={12} style={{ paddingTop: "1rem" }}>
								<select
									className="form-control user-select-none text-center overflow-hidden"
									value={selected}
									onChange={onLocalChange}
									size={state.tundishes.length + 1}
								>
									<option
										style={{ padding: "0.35rem", fontWeight: "bold" }}
										value={"all"}
									>
										All
									</option>
									{state.tundishes?.map((tundish) => {
										return (
											<option
												style={{ padding: "0.35rem" }}
												value={tundish.rootName}
											>
												Tundish {tundish.rootName}
											</option>
										);
									})}
								</select>
							</Grid>
							<Grid item md={9} xs={12} style={{ paddingTop: "1px" }}>
								<CardContent>
									<DateTimePickerComponent
										value={internalValue}
										onChange={(date: Date) => setInternalValue(date)}
									/>
									<br />
								</CardContent>
							</Grid>
							<Grid item md={12}>
								<Button
									onClick={handleRecalculate}
									fullWidth={true}
									color="primary"
									variant="contained"
									disabled={selected.length === 0}
								>
									RECALCULATE {tundishTitle(selected)}
								</Button>
							</Grid>
						</Grid>
					</Paper>
				</>
			) : (
				<Grid
					container
					justifyContent="center"
					alignItems="center"
					style={{ minHeight: "60px", paddingTop: "15rem" }}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<CircularProgress size="3rem" />
					</div>
				</Grid>
			)}
			<ErrorModal onHide={() => setLocalError(null)} error={localError} />
		</>
	);
};
